import { type ReactNode } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { authApi } from '../api/client';
import { useAuthStore } from '../stores/auth.store';

export function Layout({ children }: { children: ReactNode }) {
  const state = useAuthStore((s) => s.state);
  const setUnauthenticated = useAuthStore((s) => s.setUnauthenticated);
  const navigate = useNavigate();

  if (state.status !== 'authenticated') return null;
  const me = state.me;

  async function onLogout() {
    try { await authApi.logout(); } catch { /* ignore */ }
    setUnauthenticated();
    navigate('/');
  }

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-surface-3 bg-surface">
        <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <span className="font-heading text-lg font-semibold tracking-tight">Aurem</span>
            <span className="text-xs uppercase tracking-widest text-ink-muted">Platform Admin</span>
          </Link>
          <nav className="flex items-center gap-6 text-sm">
            <NavLink
              to="/tenants"
              className={({ isActive }) =>
                isActive ? 'text-ink' : 'text-ink-muted hover:text-ink transition'
              }
            >
              Tenants
            </NavLink>
            <span className="h-4 w-px bg-surface-3" />
            <span className="text-ink-muted text-xs">{me.email}</span>
            <button
              onClick={onLogout}
              className="text-ink-muted hover:text-ink underline-offset-4 hover:underline transition"
            >
              Sign out
            </button>
          </nav>
        </div>
      </header>
      <main className="flex-1">
        <div className="max-w-6xl mx-auto px-6 py-8">{children}</div>
      </main>
    </div>
  );
}
